<div *ngIf="committeeMeeting; else loading">
  <div
    class="mb-27 mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-between mct-items-center mct-justify-center-lt-sm mct-items-center-lt-sm"
  >
    <span *ngIf="committeeMeeting.Title; else placeholder" class="meeting-header">{{ committeeMeeting.Title }}</span>
    <ng-template #placeholder>
      <span class="light-text meeting-header">{{ 'committees.edit.committee-meetings.new-meeting' | translate | titlecase }}</span>
    </ng-template>
    <ng-container *ngTemplateOutlet="saveButtons; context: { $implicit: meetingForm }"></ng-container>
  </div>

  <div class="tabs-wrapper">
    <form #meetingForm="ngForm">
      <wlx-tabs>
        <wlx-tab [title]="'committees.edit.committee-meetings.meeting-details.title' | translate | titlecase">
          <div class="mb-27">
            <wl-committee-meeting-details-edit [committeeMeeting]="committeeMeeting"></wl-committee-meeting-details-edit>
          </div>
          <ng-container *ngTemplateOutlet="saveButtons; context: { $implicit: meetingForm }"></ng-container>
        </wlx-tab>
        <wlx-tab [title]="'committees.edit.committee-meetings.agenda.title' | translate | titlecase">
          <div class="mb-27">
            <wl-committee-meeting-agenda-edit [committeeMeeting]="committeeMeeting"></wl-committee-meeting-agenda-edit>
          </div>
          <ng-container *ngTemplateOutlet="saveButtons; context: { $implicit: meetingForm }"></ng-container>
        </wlx-tab>
        <wlx-tab [title]="'committees.edit.committee-meetings.minutes.title' | translate | titlecase">
          <div class="mb-27">
            <wl-committee-meeting-minutes-edit [committeeMeeting]="committeeMeeting"></wl-committee-meeting-minutes-edit>
          </div>
          <ng-container *ngTemplateOutlet="saveButtons; context: { $implicit: meetingForm }"></ng-container>
        </wlx-tab>
        <wlx-tab
          *ngIf="committeeMeeting?.MeetingID"
          [title]="'committees.edit.committee-meetings.attendance.title' | translate | titlecase"
        >
          <div class="mb-27">
            <wl-committee-meeting-attendance-edit [committeeMeeting]="committeeMeeting"></wl-committee-meeting-attendance-edit>
          </div>
          <ng-container *ngTemplateOutlet="saveButtons; context: { $implicit: meetingForm }"></ng-container>
        </wlx-tab>
      </wlx-tabs>
    </form>
  </div>
</div>

<ng-template #loading>
  <div class="mct-flex mct-row mct-justify-center mct-items-center">
    <wl-busy [show]="true" [isLarge]="true"></wl-busy>
  </div>
</ng-template>

<ng-template #saveButtons let-meetingForm>
  <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-12">
    <button type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button
      type="button"
      class="atlas-btn atlas-btn-primary"
      [disabled]="!meetingForm.dirty || !meetingForm.valid"
      (click)="saveAndContinue()"
    >
      <span *ngIf="!isSaving">{{ 'common.save-and-continue-editing' | translate | uppercase }}</span>
      <wl-busy *ngIf="isSaving" [show]="true"></wl-busy>
    </button>
    <button type="button" class="atlas-btn atlas-btn-primary" [disabled]="!meetingForm.dirty || !meetingForm.valid" (click)="save()">
      <span *ngIf="!isSaving">{{ 'common.save' | translate | uppercase }}</span>
      <wl-busy *ngIf="isSaving" [show]="true"></wl-busy>
    </button>
  </div>
</ng-template>
